module.exports = __webpack_public_path__ + "img/confirm.eee27062.svg";